var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Realisation"},[(_vm.newProcess)?_c('CategorySelectionModal',{attrs:{"selected":_vm.category},on:{"confirmSelection":_vm.handleSetCategory}}):_c('router-view',{key:_vm.$route.path})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }